import { Controller } from "@hotwired/stimulus"
import PhotoSwipeLightbox from "photoswipe/lightbox"
import PhotoSwipeDynamicCaption from "photoswipe-dynamic-caption-plugin"

export default class extends Controller {
  static targets = ["strip", "prev", "next"]

  connect() {
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.stripTarget,
      children: "a",
      pswpModule: () => import("photoswipe")
    })

    new PhotoSwipeDynamicCaption(this.lightbox, {
      type: "auto",
      captionContent: (slide) => slide.data.element.dataset.pswpCaption || ""
    })

    this.lightbox.init()

    this.onScroll = () => this.updateNav()
    this.onResize = () => this.updateNav()
    this.stripTarget.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onResize)
    this.updateNav()
  }

  disconnect() {
    this.lightbox?.destroy()
    this.lightbox = null
    this.stripTarget?.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onResize)
  }

  prev() { this.scrollByStep(-1) }
  next() { this.scrollByStep(1) }

  scrollByStep(dir) {
    const step = Math.round(this.stripTarget.clientWidth * 0.8) * dir
    this.stripTarget.scrollBy({ left: step, behavior: "smooth" })
  }

  updateNav() {
    const s = this.stripTarget
    const overflow = s.scrollWidth > s.clientWidth + 1
    const atStart = s.scrollLeft <= 1
    const atEnd = Math.ceil(s.scrollLeft + s.clientWidth) >= s.scrollWidth - 1

    if (this.hasPrevTarget) this.prevTarget.classList.toggle("is-hidden", !overflow || atStart)
    if (this.hasNextTarget) this.nextTarget.classList.toggle("is-hidden", !overflow || atEnd)
  }
}
